import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ContextService } from '@services/context.service'
import { Observable, Subject, combineLatest, map, of, takeUntil } from 'rxjs'
import { Venue } from '@app/domain/Venue'
import { Business } from '@app/domain/Business'

@Component({
    selector: 'app-venue-selection',
    templateUrl: './venue-selection.component.html',
})
export class VenueSelectionComponent implements OnInit, OnDestroy {

    @Input() compact = false
    business$!: Observable<Business | null>
    venue$!: Observable<Venue | null>
    businesses$!: Observable<Business[]>
    dropdownTitle$: Observable<string>
    private onDestroy$ = new Subject<void>()

    constructor(
        private contextService: ContextService
    ) {
        this.dropdownTitle$ = of('Select Venue')
    }

    ngOnInit() {
        this.businesses$ = combineLatest([
            this.contextService.organisation$,
            this.contextService.user$
        ]).pipe(
            takeUntil(this.onDestroy$),
            map(([organisation, user]) => {
                if (!organisation || !user) {
                    return []
                }
                return this.contextService.getBusinessesUserWorksIn(organisation, user)
                .filter(business => business.venues.length > 0)
            })
        )
        this.business$ = this.contextService.business$.pipe(
            takeUntil(this.onDestroy$)
        )
        this.venue$ = this.contextService.venue$.pipe(
            takeUntil(this.onDestroy$)
        )
        this.dropdownTitle$ = this.venue$.pipe(
            takeUntil(this.onDestroy$),
            map((venue) => {
                return venue ? venue.displayName : 'Select Venue'
            })
        )
    }

    ngOnDestroy() {
        this.onDestroy$.next()
        this.onDestroy$.complete()
    }

    getBusinessVenues(business: Business): Observable<Venue[]> {
        return this.contextService.user$.pipe(
            takeUntil(this.onDestroy$),
            map(user => {
                if (!user) {
                    return []
                }
                return business.venuesUserWorksIn(user)
            })
        )
    }

    selectBusinessAndVenue(business: Business, venue: Venue) {
        this.contextService.setBusiness(business)
        this.contextService.setVenue(venue)
    }

    isSelected(business: Business, venue: Venue): boolean {
        const currentBusiness = this.contextService.getBusiness()
        const currentVenue = this.contextService.getVenue()

        return currentBusiness?.id === business.id && currentVenue?.id === venue.id
    }
}
